import * as React from 'react';
import Tooltip, { TooltipProps } from '@material-ui/core/Tooltip';
import { withStyles, Theme } from '@material-ui/core/styles';
import { fontFamilies } from '../../theme/text';

const CustomTooltip = withStyles((theme: Theme) => ({
  arrow: {
    color: 'rgba(48, 65, 84, 0.85)'
  },
  tooltip: {
    backgroundColor: 'rgba(48, 65, 84, 0.85)',
    fontFamily: fontFamilies.heading,
    fontSize: '12',
    fontWeight: 300
  }
}))(Tooltip);

const customPopperProps = {
  disablePortal: true,
  modifiers: {
    flip: {
      enabled: false
    },
    offset: {
      offset: '0, -8'
    }
  }
};

const IconButtonTooltip = (props: TooltipProps) => {
  return (
    <CustomTooltip {...props} arrow PopperProps={customPopperProps}>
      {props.children}
    </CustomTooltip>
  );
};

export default IconButtonTooltip;
